module.exports = __webpack_public_path__ + "img/about-icons-mission-web.5562c900.svg";